import React from 'react';
import { SpinningBaseball } from './baseballAssets';
import { dynastyTheme } from '../../../services/colorService';
import { mobilePageBackground } from '../../../services/mobileStyleService';

const MobileAuthLoading = ({ message = 'Loading...' }) => {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ background: mobilePageBackground }}
    >
      {/* Spinning Baseball */}
      <div className="mb-6">
        <SpinningBaseball />
      </div>
      
      {/* Loading Message */}
      <p className={`text-lg ${dynastyTheme.classes.text.neutralLighter} animate-pulse`}>
        {message}
      </p>
    </div>
  );
};

export default MobileAuthLoading;
